export default "__VITE_ASSET__BTpeb9vh__"